import { makeAutoObservable } from "mobx";
import AuthService from "../services/AuthService";
import UserService from "../services/UserService";
import ProjectService from "../services/ProjectService";
import DashBoardService from "../services/DashBoardService";
import TaskService from "../services/TaskService";
import FileService from "../services/FileService";
import CommonService from "../services/CommonService";
import TeamService from "../services/TeamService";
import FilterService from "../services/FilterDataService";
import { SelectedOptions } from "../models/FilterModels/IFilterModel";
import { IBreadCrumb } from "../models/IBreadCrumb";
import ColumnService from "../services/ColumnService";
import { IRecoverPassword } from "../common/api_interfaces/user/IRecoverPassword";
import { IFeedback } from "../common/api_interfaces/common/IFeedback";
import { IGetRole } from "../common/api_interfaces/role/IGetRole";
import { IGetOneRole } from "../common/api_interfaces/role/IGetOneRole";
import { IEditRole } from "../common/api_interfaces/role/IEditRole";
import { ICreateRole } from "../common/api_interfaces/role/ICreateRole";
import UserMonitorService from "../services/UserMonitorService";
import { IFunctionPermissions } from "../common/api_interfaces/role/IFunctionPermissions";
import { IChangePassword } from "../common/api_interfaces/user/IChangePassword";
import { IPersonalSettings } from "../common/api_interfaces/user/IPersonalSettings";
import { DataStore } from "../DataStore";
import $api from "..";
import ChatService from "../services/ChatService";
import BasketService from "../services/BasketService";
import NotificationService from "../services/NotificationService";
import { SearchService } from "../services/SearchService";
import { IBoardSavedFilters } from "../models/BoardModels/IBoardSavedFilters";
import LicenseService from "../services/LicenseService";
import { IAvailableModules } from "../common/api_interfaces/license/IAvailableModules";
import { IUpgradeCount } from "../common/api_interfaces/license/IUpgradeCount";
import { AxiosResponse } from "axios";
import { IOptionsQueryParams } from "../helpers/paramsAutoFiller";
import { ITaskSaveOptions } from "../models/TaskModels/ITaskSaveOptions";
import { IPersonRole } from "../common/api_interfaces/user/IPersonRole";
import { IUserStatus } from "../common/api_interfaces/user/IUserStatus";
import { IPersonWithStatus } from "../common/api_interfaces/user/IPersonWithStatus";
import { IEditPersonalSettingsRequest } from "../common/api_interfaces/user/IEditPersonalSettings";
import { ISideBar } from "../common/api_interfaces/common/ISideBar";
import { IUnarchiveProjects } from "../common/api_interfaces/archive/IUnarchiveProjects";
import { ICardProject } from "../common/api_interfaces/project/ICardProjectProject";
import { IProjectGeneralInfo } from "../common/api_interfaces/project/IProjectGeneralInfo";
import { IProjectProgressInfo } from "../common/api_interfaces/project/IProjectProgressInfo";
import { IProjectHistoryDisplay } from "../common/api_interfaces/history/IProjectHistoryDisplay";
import { IGetProjectHistoryDisplay } from "../common/api_interfaces/history/IGetProjectHistoryDisplay";
import { IProjectDeleteReq } from "../common/api_interfaces/project/IProjectDeleteReq";
import { IDashBoardEditReq } from "../common/api_interfaces/board/IDashBoardEditReq";
import { IColumnDisplay } from "../common/api_interfaces/column/IColumnDisplay";
import { IDeleteBoard } from "../common/api_interfaces/board/IDeleteBoard";
import { IRestrictBoard } from "../common/api_interfaces/board/IRestrictBoard";
import { IRestrictBoardView } from "../common/api_interfaces/board/IRestrictBoardView";
import { ISystemDeletePerson } from "../common/api_interfaces/user/ISystemDeletePerson";
import { IFullUserInfo, IUserInfo } from "../common/api_interfaces/user/IUserInfo";
import { IProjectCreateReq } from "../common/api_interfaces/project/IProjectCreateReq";
import { IProjectEditReq } from "../common/api_interfaces/project/IProjectEditReq";
import { FunctionsAccessRequest } from "../common/api_interfaces/role/FunctionsAccessRequest";
import { IEditElemSettings, IElemSettings } from "../common/api_interfaces/settings/IElemSettings";
import { personalSettings } from "../common/enums/personalSettings";
import { IGroupFunction } from "../common/api_interfaces/role/IFunctions";
import { IPersonWithRolesToExcludePermissions } from "../common/api_interfaces/role/IRole";
import { IExcludePermission } from "../common/api_interfaces/role/IExcludePermission";

export default class Store {
    static taskService: any;
    constructor() {
        makeAutoObservable(this);
        // Если в localStorage есть информация о польозвателе, то флаги выставляются true,
        // если сессия устарела, или отсутствовала вовсе, то после первого запроса к серверу флаг isAuth
        // будет выставлен на false
        const userString = localStorage.getItem("user");
        const user = userString ? (JSON.parse(userString) as IFullUserInfo) : null;
        if (user) {
            this.isAuth = true;
            this.isActivate = user.isActivated;
            this.setUser(user);
        }
        this.userMonitorShowFavourite = localStorage.getItem("user-monitor-show-favourite") === "true";
        this.boardsSavedFilters = JSON.parse(localStorage.getItem("boards-filters") ?? "[]");
        this.leftMenuCollapsed = localStorage.getItem("left-menu-collapsed") === "true";
    }

    // #region ENV params
    loadEnvParams() {
        $api.get("/System/getParams").then((x) => {
            let dataStorage = new DataStore(x);
            this.OAUTH_CLIENT_ID = dataStorage.OAUTH_CLIENT_ID ?? "";
            this.EXT_URL = dataStorage.EXTERNAL_URL ?? "";
            this.BLOCK_SUBTASKS = dataStorage.BLOCK_SUBTASKS;
            this.BLOCK_PROJECT_REPORTS = dataStorage.BLOCK_PROJECT_REPORTS;
            this.BLOCK_ARCHIVE = dataStorage.BLOCK_ARCHIVE;
            this.SOCKET_URL = dataStorage.SOCKET_URL ?? "";
        });
    }

    private OAUTH_CLIENT_ID: string = "";
    private EXT_URL: string = "";
    private BLOCK_SUBTASKS: boolean = false;
    private BLOCK_PROJECT_REPORTS: boolean = false;
    private BLOCK_ARCHIVE: boolean = false;
    private SOCKET_URL: string = "";

    getSocketUrl(): string {
        return this.SOCKET_URL;
    }

    getOAuthId(): string {
        return this.OAUTH_CLIENT_ID;
    }

    getExtUrl(): string {
        return this.EXT_URL;
    }

    getBlockSubtasks(): boolean {
        return this.BLOCK_SUBTASKS;
    }

    getBlockArchive(): boolean {
        return this.BLOCK_ARCHIVE;
    }

    getBlockProjectReports(): boolean {
        return this.BLOCK_PROJECT_REPORTS;
    }

    // #endregion Env params

    // #region Экземпляры сервисов

    authService = new AuthService();
    basketService = new BasketService();
    chatService = new ChatService();
    columnService = new ColumnService();
    commonService = new CommonService();
    dashBoardService = new DashBoardService();
    fileService = new FileService();
    filterService = new FilterService();
    projectService = new ProjectService();
    taskService = new TaskService();
    teamService = new TeamService();
    userMonitorService = new UserMonitorService();
    userService = new UserService();
    notificationService = new NotificationService();
    searchService = new SearchService();
    licenseService = new LicenseService();

    // #endregion Экземпляры сервисов
    // #region Информация, хранящаяся в localStorage
    user: IUserInfo = {} as IUserInfo;

    setUser(user: IUserInfo) {
        this.user = {...user};
        localStorage.setItem("user", JSON.stringify(user));
    }


    // #region Работа с Quill

    textQuill: {
        param: IOptionsQueryParams,
        href: string,
        text: string,
    }[] = [];

    private checkQuillBlock(param: IOptionsQueryParams, href: string) {
        const existingIndex = this.textQuill.findIndex(item => 
            item.param.page === param.page &&
            item.param.entity === param.entity &&
            item.param.action === param.action &&
            item.param.entityId === param.entityId &&
            item.param.cheklistId === param.cheklistId &&
            item.href === href
        );

        return existingIndex
    }

    setBlockTextQuill(param: IOptionsQueryParams, newValue: string, href: string) {
        const existingIndex = this.checkQuillBlock(param, href);
        
        if (existingIndex !== -1) {
            this.textQuill[existingIndex].text = newValue;
        } else {
            this.textQuill.push({ param: param, text: newValue, href });
        }
    }

    getBlockTextQuill(param: IOptionsQueryParams, href: string) {
        const existingIndex = this.checkQuillBlock(param, href);

        if (existingIndex !== -1) {
            return this.textQuill[existingIndex];
        } else {
            return undefined;
        }
    }

    clearCurrentBlocksTextQuill(param: IOptionsQueryParams, href: string) {    
        this.textQuill = this.textQuill.filter(item => 
            item.param.page === param.page &&
            item.param.entity === param.entity &&
            item.param.action === param.action &&
            item.param.entityId === param.entityId &&
            item.param.cheklistId === param.cheklistId &&
            item.href === href
        );
    }

    clearAllBlocksTextQuill() {
        this.textQuill = [];
    }

    // #endregion Работа с Quill

    // #region Поля создания задачи
    addEditTaskData: {
        param: IOptionsQueryParams,
        data: ITaskSaveOptions,
    } | undefined;

    setAddEditTaskData(param: IOptionsQueryParams, data: ITaskSaveOptions) {
        this.addEditTaskData = {param: param, data: data};
    }

    getAddEditTaskData() {
        return this.addEditTaskData;
    }

    clearAddEditTaskData() {
        this.addEditTaskData = undefined;
    }

    // #endregion создания задачи

    // #region returnUrl

    returnUrl: string = "";

    setReturnUrl(url: string) {
        this.returnUrl = url;
    }

    getReturnUrl() {
        return this.returnUrl;
    }

    // #endregion returnUrl

    userMonitorShowFavourite: boolean = false;

    setUserMonitorShowFavourite(flag: boolean) {
        this.userMonitorShowFavourite = flag;
        localStorage.setItem("user-monitor-show-favourite", JSON.stringify(flag));
    }

    boardsSavedFilters: IBoardSavedFilters[] = [];

    getBoardSavedFilters(boardId: number): SelectedOptions {
        const setting = this.personalSettings.find((p) => p.paramName === personalSettings.saveBoardFilters);
        if (!setting || setting.value) {
            //Если нет записи об этой настройке или если есть запись и значение "true"
            const foundFilters = this.boardsSavedFilters.find((f) => f.boardId === boardId);
            return foundFilters?.selectedFilters ?? {};
        } else {
            return {};
        }
    }

    setBoardsSavedFilters(boardId: number, options: SelectedOptions) {
        const foundFilters = this.boardsSavedFilters.find((f) => f.boardId === boardId);
        if (foundFilters) foundFilters.selectedFilters = options;
        else
            this.boardsSavedFilters.push({
                boardId: boardId,
                selectedFilters: options,
            });
        localStorage.setItem("boards-filters", JSON.stringify(this.boardsSavedFilters));
    }

    leftMenuCollapsed: boolean = false;

    setLeftMenuCollapsed(collapsed: boolean) {
        this.leftMenuCollapsed = collapsed;
        localStorage.setItem("left-menu-collapsed", JSON.stringify(collapsed));
    }

    // #endregion Информация, хранящаяся в localStorage

    personalSettings: IPersonalSettings[] = [];

    setPersonalSettings(settings: IPersonalSettings[]) {
        this.personalSettings = settings;
    }

    deletePersons: boolean = true;

    setDeletePersons(set: boolean) {
        this.deletePersons = set;
    }

    userWithStatus: IPersonWithStatus = {} as IPersonWithStatus;

    setUserWithStatus(userWithStatus: IPersonWithStatus) {
        this.userWithStatus = userWithStatus;
    }

    currentProjectId: number = 0;

    setCurrentProjectId(val: number) {
        this.currentProjectId = val;
    }

    currentBoardId: number = 0;

    setCurrentBoard(val: number) {
        this.currentBoardId = val;
    }

    currentBoardData: IBreadCrumb = {} as IBreadCrumb;

    setCurrentBoardData(val: IBreadCrumb) {
        this.currentBoardData = val;
    }

    projects: ICardProject[] = [];

    columns: IColumnDisplay[] = [];

    isAuth: boolean = false;
    isActivate: boolean = false;
    availableModues: IAvailableModules = {
        base: false,
        userMonitor: false,
        archive: false,
        checkLists: false,
        multiBoards: false,
    };
    upgradeCount: IUpgradeCount = { multiBoards: 0 };
    isDrag: boolean = true;

    getAvailableModules() {
        return this.availableModues;
    }

    getUpgradeCount() {
        return this.upgradeCount;
    }

    //Настройки

    setDrag(drag: boolean) {
        this.isDrag = drag;
    }

    linkNewPerson: string = "";

    setLinkNewPerson(saveLinkNewPerson: string) {
        this.linkNewPerson = saveLinkNewPerson;
    }

    sideBar: ISideBar = { projects: [] };

    updateFile: boolean = false;

    systemSettings: IElemSettings[] = [];

    setSystemSettings(settings: IElemSettings[]) {
        this.systemSettings = settings;
    }

    setUpdateFile(bool: boolean) {
        this.updateFile = bool;
    }

    setActivate(bool: boolean) {
        this.isActivate = bool;
    }

    setAuth(bool: boolean) {
        this.isAuth = bool;
    }

    setProjects(projects: ICardProject[]) {
        this.projects = projects;
    }

    setColumns(columns: any) {
        this.columns = columns;
    }

    personsWithRoles: IPersonRole = {} as IPersonRole;

    setPersonsWithRoles(personsWithRoles: IPersonRole) {
        this.personsWithRoles = personsWithRoles;
    }

    dataForFilter: any;

    setDataForFilter(dataForFilter: any) {
        this.dataForFilter = dataForFilter;
    }

    async login(email: string, password: string) {
        const response = await AuthService.login(email, password);
        await this.handleLoginResponse(response);

    }

    async loginOAuth(access_token: string) {
        const response = await AuthService.loginOAuth(access_token);
        await this.handleLoginResponse(response);
    }

    private async handleLoginResponse(response: AxiosResponse<IUserInfo>) {
        await this.checkAvailableModules();
        await this.checkUpgradeCount();
        this.setAuth(true);
        this.setActivate(response.data.isActivated);
        this.setUser(response.data);
    }

    async getCurrentUser(): Promise<void> {
        try {
            const response = await AuthService.fetchCurentUser();

            this.setUser(response.data);
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async logout() {
        try {
            await AuthService.logout();

            this.setAuth(false);
            this.setUser({} as IFullUserInfo);
            localStorage.removeItem("user");

            return true;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async hasPermission(check: FunctionsAccessRequest): Promise<IFunctionPermissions[]> {
        try {
            const response = await CommonService.hasPermission(check);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
            return [];
        }
    }

    async getDataLinkPerson(link: string): Promise<IPersonWithStatus | undefined> {
        try {
            const response = await UserService.getDataLinkPerson(link);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getUserAllStatuses(): Promise<IUserStatus[] | undefined> {
        try {
            const response = await UserService.getAllUserStatuses();

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getUser(userId: number): Promise<IFullUserInfo | undefined> {
        try {
            const response = await UserService.getUser(userId);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }
    
    async getPersonalSettings(): Promise<any> {
        try {
            const response = await UserService.getPersonalSettings();
            this.setPersonalSettings(response.data);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async editPersonalSettings(editSettings: IEditPersonalSettingsRequest): Promise<any> {
        try {
            const response = await UserService.editPersonalSettings(editSettings);
            this.setPersonalSettings(response.data);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async deleteSystemPerson(data: ISystemDeletePerson[]): Promise<any> {
        try {
            const response = await CommonService.deleteSystemPerson(data);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getNameAllRoles(): Promise<IGetRole[] | undefined> {
        try {
            const response = await CommonService.getNameAllRoles();
            let systemRole = response.data.filter((xx) => xx.requiredProject === 0);

            return systemRole;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async deleteImg(img: string): Promise<any> {
        try {
            let data: { img: string } = { img: img };
            const response = await CommonService.deleteImg(data);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async saveRestrict(restrict: IRestrictBoard): Promise<any> {
        try {
            const response = await CommonService.saveRestrict(restrict);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async saveExcludeAccessPermission(data: IExcludePermission): Promise<any> {
        try {
            const response = await CommonService.saveExcludeAccessPermission(data);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getAllAvailablePermissions(): Promise<IGroupFunction[] | undefined> {
        try {
            const response = await CommonService.getAllAvailablePermissions();

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getDataToExcludePermissions(id: number): Promise<IPersonWithRolesToExcludePermissions | undefined> {
        try {
            const response = await CommonService.getDataToExcludePermissions(id);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async deleteRole(id: number): Promise<any> {
        try {
            const response = await CommonService.deleteRoles({ id: [id] });

            return response;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async deleteRoles(data: { id: number[] }): Promise<any> {
        try {
            const response = await CommonService.deleteRoles(data);

            return response;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getRole(id: number): Promise<IGetOneRole | undefined> {
        try {
            const response = await CommonService.getRole(id);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async createRole(data: ICreateRole): Promise<any> {
        try {
            const response = await CommonService.createRole(data);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async editRole(data: IEditRole): Promise<any> {
        const response = await CommonService.editRole(data);

        return response.data;
    }

    async getAllRoles(): Promise<IGetRole[] | undefined> {
        try {
            const response = await CommonService.getAllRoles();

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async deleteAllFilesWithoutBind() {
        try {
            const response = await CommonService.deleteAllFilesWithoutBind();

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getAllProject(includeSubprojects: boolean) {
        try {
            const response = await ProjectService.getAllProject(includeSubprojects);

            this.setProjects(response.data);
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getArchiveProjects() {
        try {
            const response = await ProjectService.getArchiveProjects();

            this.setProjects(response.data);
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async addDashBoard(name: string, projectId: number) {
        try {
            await DashBoardService.addDashBoard({name, projectId});
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async editBoard(body: IDashBoardEditReq): Promise<void> {
        try {
            await DashBoardService.editBoard(body);
        } catch (err: any) {
            console.log(err.response?.data?.message);
            throw err;
        }
    }

    async getProjectIdDashBoards(id: number) {
        try {
            let response = await DashBoardService.getProjectIdDashBoards(id);

            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getAllColumnsBoard(id: number) {
        try {
            const response = await DashBoardService.getAllColumnBoard(id);
            this.setColumns(response.data);
            return response.data;
        } catch (err: any) {
            this.setColumns([]);
            console.log(err.response?.data?.message);
            return null;
        }
    }

    async deleteBoard(body: IDeleteBoard): Promise<void> {
        try {
            await DashBoardService.deleteBoard(body);
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }    

    async editSystemSettings(newSettings: IEditElemSettings[]): Promise<any> {
        try {
            const res = await CommonService.editSystemSettings(newSettings);
            return res.data;
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async activatePerson(link: string): Promise<any> {
        try {
            const res = await AuthService.activatePerson(link);
            return res.data;
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async getSystemSettings(): Promise<IElemSettings[]> {
        try {
            const res = await CommonService.getSystemSettings();
            this.setSystemSettings(res.data);
            return res.data;
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async getPublicSettings(): Promise<IElemSettings[]> {
        try {
            const res = await CommonService.getPublicSettigns();
            return res.data;
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async getProjectProgressData(projectId: number): Promise<IProjectProgressInfo | null> {
        try {
            const response = await ProjectService.getProjectProgressData(projectId);

            return response.data;
        } catch (err: any) {
            return err.message;
        }
    }

    async getProjectGeneralInfo(projectId: number): Promise<IProjectGeneralInfo | null | number> {
        try {
            const response = await ProjectService.getProjectGeneralInfo(projectId);

            return response.data;
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async getProjectHistoryDisplayData(body: IGetProjectHistoryDisplay): Promise<IProjectHistoryDisplay[]> {
        try {
            const response = await ProjectService.getProjectHistoryDisplayData(body);
            return response.data;
        } catch (err: any) {
            return err;
        }
    }

    async registration(email: string, password: string, name: string, surname: string, middlename: string) {
        try {
            await AuthService.registration(email, password, name, surname, middlename);
        } catch (err: any) {
            return err.response?.status;
        }
    }

    // Метод проверки активированности пользователя
    // Вызывается если при логине в DTO пользователя isActivate = false
    async checkActivate(email: string) {
        try {
            const response = await AuthService.checkActivate(email);
            if (response.data.isActivated === true) {
                this.setActivate(true);
                this.setAuth(true);
            }
            const userString = localStorage.getItem("user");
            const user = userString ? (JSON.parse(userString) as IFullUserInfo) : null;
            if (user) {
                user.isActivated = true;
                this.setUser(user);
            }
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async checkAvailableModules() {
        try {
            const modules = await this.licenseService.getAvailableModules();
            this.availableModues = modules.data;
        } catch (err) { }
    }

    async checkUpgradeCount() {
        try {
            const modules = await this.licenseService.getUpgradeCount();
            this.upgradeCount = modules.data;
        } catch (err) { }
    }

    async requestPasswordRecover(email: string) {
        try {
            await AuthService.requestPasswordRecover(email);
        } catch (err: any) {
            return err.response?.status;
        }
    }

    async recoverPassword(body: IRecoverPassword) {
        try {
            await AuthService.recoverPassword(body);
        } catch (err: any) {
            return err.response.data;
        }
    }

    async changePassword(body: IChangePassword) {
        try {
            return await AuthService.changePassword(body);
        } catch (err: any) {
            return err.response;
        }
    }

    async restrictAccess(projectId: number): Promise<IRestrictBoardView | undefined> {
        try {
            const response = await CommonService.restrictAccess(projectId);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getProjectsForLeftMenu() {
        try {
            const response = await CommonService.getProjects();
            if (response.data) this.sideBar = response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async addFeedback(reqBody: IFeedback) {
        try {
            await CommonService.addFeedback(reqBody);
        } catch (err: any) {
            return err.response?.data;
        }
    }

    async getSystemPersonWithRoles() {
        try {
            const response = await UserService.getSystemPersonWithRoles();
            this.setPersonsWithRoles(response.data);
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async createProject(body: IProjectCreateReq) {
        try {
            const response = await ProjectService.createProject(body);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async editProject(body: IProjectEditReq) {
        try {
            const response = await ProjectService.editProject(body);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async deleteProject(body: IProjectDeleteReq) {
        try {
            const response = await ProjectService.deleteProject(body);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async archiveProject(projectId: number) {
        try {
            const response = await ProjectService.archiveProject(projectId);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async unarchiveProjects(body: IUnarchiveProjects) {
        try {
            const response = await ProjectService.unarchiveProjects(body);
            return response.data;
        } catch (err: any) {
            console.log(err.response?.data?.message);
        }
    }

    async getVersion() {
        const response = await CommonService.getVersion();
        return response.data;
    }
}
